import {AfterViewInit, Component, Input} from "@angular/core";
import { environment } from "@environments";

/*Services */
import { WorksService } from "@services";
import Swiper from "swiper";


@Component({
    selector: "image-slider",
    templateUrl: "./image-slider.component.html",
    standalone: false,
})
export class ImageSliderComponent  implements AfterViewInit {

	@Input("imagesList") imagesList;
	baseUrl: string = environment.url;
	slider: Swiper;

	constructor(
		private worksService: WorksService,
	) { }

	playVideo(id, type) {
		this.worksService.playVideoSubject.next({ id: id, type: type });
	}

	ngAfterViewInit() {
		this.initializeSwiper();
	}

	initializeSwiper() {
		this.slider = new Swiper(".swiper-container", {
			loop: true,
			speed: 800,
			slidesPerView: 1,
			slidesPerGroup: 1
		});
	}
}
